// extracted by mini-css-extract-plugin
module.exports = {"row":"ModuleRow_row_mrj7K","textOverflowEllipsis":"ModuleRow_textOverflowEllipsis_2sKyn"};